angular.module('impactx.rfxsupplier').controller('RFXSupplierCustomerItemsCtrl', [
    'RFXSupplierService',
    RFXSupplierCustomerItemsController
]);

function RFXSupplierCustomerItemsController(RFXSupplierService) {
    var self = this;

    self.$onInit = function () {
        self.cardExpanded = !self.isClosed;
    };

    self.toggleCardExpansion = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        self.cardExpanded = !self.cardExpanded;
    };

    self.isInformation = function (item) {
        var policy;
        if (item.smartForm) {
            policy = RFXSupplierService.getSmartFormPolicy(item.smartForm.identifier, self.smartFormPolicies);
        }
        return item.isInformation || (policy && policy.isInformation);
    }

    self.addItemFromCustomer = function (event, item) {
        self.onItemAdded({event: event, item: item});
    };
}